import { createServerFn } from "@tanstack/react-start";
import { FRAMEWORK_BY_AGENT, FALLBACK_INSIGHTS } from "./council-insights.server";

export interface CouncilInsight {
  pair: string;
  agent: string;
  framework: string;
  excerpt: string;
  ageMins: number;
}

export const getCouncilInsights = createServerFn({ method: "GET" }).handler(async (): Promise<{ insights: CouncilInsight[] }> => {
  try {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const { data } = await supabaseAdmin
      .from("signals")
      .select("pair, created_at, payload")
      .not("payload", "is", null)
      .order("created_at", { ascending: false })
      .limit(40);

    const out: CouncilInsight[] = [];
    const seenPairs = new Set<string>();
    const now = Date.now();

    for (const row of data ?? []) {
      const payload = row.payload as unknown as { verdict?: { votes?: Array<{ agentName?: string; layer?: string; reasoning?: string; richReasoning?: string }> } } | null;
      const votes = payload?.verdict?.votes ?? [];
      for (const v of votes) {
        if (v.layer && v.layer !== "GENERATOR") continue;
        const text = (v.richReasoning || v.reasoning || "").trim();
        const agent = (v.agentName || "").trim();
        if (!text || !agent || text.length < 40) continue;
        const key = `${row.pair}-${agent}`;
        if (seenPairs.has(key)) continue;
        seenPairs.add(key);
        out.push({
          pair: row.pair,
          agent,
          framework: FRAMEWORK_BY_AGENT[agent] ?? "Specialist view",
          excerpt: text.length > 220 ? text.slice(0, 217) + "…" : text,
          ageMins: Math.max(1, Math.round((now - new Date(row.created_at).getTime()) / 60000)),
        });
        if (out.length >= 6) break;
      }
      if (out.length >= 6) break;
    }

    if (out.length === 0) return { insights: FALLBACK_INSIGHTS };
    if (out.length < 3) return { insights: [...out, ...FALLBACK_INSIGHTS].slice(0, 6) };
    return { insights: out };
  } catch {
    return { insights: FALLBACK_INSIGHTS };
  }
});
